/** Offset from the DPAD center to the pin tip (above-left). dpadCenter + PIN_TIP_OFFSET = pinTip.
 *  x=-24 puts the tip at the left edge of the DPAD circle; y=-27 puts it ~1.5px above the top edge. */
export const PIN_TIP_OFFSET = { x: -24, y: -27 };

export const CURSOR_DRAGGER_SIZE = 51;
